Namespace.create("cv.Views.Setup").RegistrationPaymentView = Marionette.LayoutView.extend({
  className: "view-setup-registration",

  getTemplate: function () {
    if (_.isEmpty(cv.project.get("registration"))) {
      return cv.Templates["setup/registration/view"];
    } else {
      return cv.Templates["setup/registration/complete"];
    }
  },

  uiBindings: {
    ":el": {
      observe: ["entering_promo_code", "promo_text"],
      update: function ($el, value, model, options) {
        // Toggle for showing/entering code
        if (model.get("entering_promo_code") == true) {
          $el.find("#promo_code").val("");
          $el.find("#promo_code").removeClass("has-error");
          $el.find(".promo-code-wrapper").show();
          $el.find(".enter-promo-code").hide();
        } else {
          $el.find(".promo-code-wrapper").hide();
          $el.find(".enter-promo-code").show();
        }

        if (model.get("promo_text") != "") {
          $el.find(".enter-promo-code").hide();
        }

        // Toggle for applied
        if (model.get("promo_text") == "") {
          $el.find(".applied-code-wrapper").hide();
        } else {
          $el.find(".applied-code-wrapper").html(model.get("promo_text"));
          $el.find(".applied-code-wrapper").show();
        }
      },
    },
  },

  events: {
    "click .enter-promo-code": "enterPromoCode",
    "click .apply-code": "applyCode",
    "click .remove-code": "removeCode",
    "click .form-save": "next",
  },

  childEvents: {
    calculate_total: function (childView, msg) {
      // See if we have a free tier
      var has_free_tier = false;
      var has_quantity = false;
      this.registration_tiers.each(function (model) {
        if (model.get("amount") == 0) {
          has_free_tier = true;
        }
        if (model.get("quantity") > 0) {
          has_quantity = true;
        }
      });

      if (this.registration_model.get("amount") == 0 && has_free_tier == true) {
        this.$("#payment-details").hide();
      } else if (this.registration_model.get("amount") == 0 && has_quantity == true) {
        this.$("#payment-details").hide();
      } else {
        this.$("#payment-details").show();
      }
    },
  },

  regions: {
    region_tiers: "#region-tiers",
  },

  validation: {},

  templateHelpers: function () {
    return {
      sub_description:
        cv.campaign.get("enable_registration_quantity") == 1
          ? "Select from the tier/quantities below."
          : "Select from the tiers below.",
      enable_registration_promo_code:
        cv.campaign.get("enable_registration_promo_code") == 1 ? true : false,
    };
  },

  initialize: function (options) {
    this.options = _.extend(this.options, options);

    // Registration model
    this.ui_model = new Backbone.Model({
      entering_promo_code: false,
      promo_text: "",
    });
    this.registration_model = new Backbone.Model({
      first_name: cv.user.get("first_name"),
      last_name: cv.user.get("last_name"),
      email: cv.user.get("email"),
      quantity: 0,
      amount: 0,
      promo_code: "",
    });
    this.discount_model = new Backbone.Model({
      type: "",
      value: "",
    });

    // Fill with new or current registration
    if (_.isEmpty(cv.project.get("registration"))) {
      this.registration_tiers = new Backbone.Collection(cv.campaign.get("registration_tiers"));
    } else {
      var tmp = [];
      _.each(
        cv.project.get("registration.line_items"),
        function (item) {
          tmp.push({
            id: item.tier_id,
            campaign_id: cv.campaign.get("id"),
            description: item.description,
            amount: item.amount,
          });
        },
        this
      );
      this.registration_tiers = new Backbone.Collection(tmp);
    }

    // Stripe stuff
    this.stripe = Stripe(cv.PRELOADED.stripe_publishable_key);
    this.submitting_payment = false;

    console.log("SetupProfileView initialized.");
  },

  next: function (e) {
    e.preventDefault();

    vent.trigger("notif:clear");

    if (_.isEmpty(cv.project.get("registration"))) {
      this.$(".tiers").removeClass("has-error");

      if (this.registration_model.get("quantity") == 0) {
        this.$(".tiers").addClass("has-error");
        vent.trigger("notif:error", "Please select at least one quantity.");
        return false;
      }

      if (this.submitting_payment == false) {
        this.submitting_payment = true;

        // If we are charging a card, do this...
        if (this.registration_model.get("amount") == 0) {
          this.$(".form-save").text("Processing...");
          this.$(".form-save").addClass("button-disabled");

          // Add in a fake delay of about 1.25 seconds
          setTimeout(
            _.bind(function () {
              this.processPayment(null);
            }, this),
            1250
          );
        } else {
          this.createToken();
        }
      }
    } else {
      vent.trigger("setup:next_screen");
    }
  },

  enterPromoCode: function (e) {
    e.preventDefault();

    this.ui_model.set("entering_promo_code", true);
  },

  applyCode: function (e) {
    e.preventDefault();

    // Verify the promo code
    $.ajax({
      cache: false,
      type: "POST",
      url: cv.api_path + "/registrations/check_promo_code",
      data: {
        promo_code: this.$("#promo_code").val(),
      },
      dataType: "json",
      success: _.bind(function (data) {
        // Set the discount
        this.discount_model.set({
          type: data.discount_type,
          value: data.discount_value,
        });

        // Set the promo code
        this.registration_model.set("promo_code", data.promo_code);

        // Update UI
        this.ui_model.set({
          entering_promo_code: false,
          promo_text:
            'Promo code "' +
            data.promo_code +
            '" is applied. <a class="remove-code" href="#">Remove</a>',
        });

        vent.trigger("notif:success", "Promo code has been applied.");
      }, this),
      error: _.bind(function (xhr, error) {
        this.$("#promo_code").addClass("has-error");
        vent.trigger("notif:error", xhr.responseJSON.message);
      }, this),
    });
  },

  removeCode: function (e) {
    e.preventDefault();

    // Remove discount
    this.discount_model.set({
      type: "",
      value: "",
    });

    // Remove promo code
    this.registration_model.set("promo_code", "");

    // Update UI
    this.ui_model.set({
      entering_promo_code: false,
      promo_text: "",
    });
  },

  createToken: function () {
    this.$(".form-save").text("Processing...");
    this.$(".form-save").addClass("button-disabled");

    this.stripe.createToken(this.card).then(
      _.bind(function (result) {
        if (result.error) {
          this.submitting_payment = false;
          this.$(".form-save").html(
            'Process Payment <i class="material-icons md-24">chevron_right</i>'
          );
          this.$(".form-save").removeClass("button-disabled");
          vent.trigger("notif:error", result.error.message);
        } else {
          this.processPayment(result.token);
        }
      }, this)
    );
  },

  processPayment: function (token) {
    // Trying to pass a fraudulent card by bypass CVC
    if (!_.isNull(token) && _.isNull(token.card.cvc_check)) {
      vent.trigger("notif:error", "Please enter a valid CVC code.");
    }

    // Submit for processing
    $.ajax({
      cache: false,
      type: "POST",
      url: cv.api_path + "/registrations/process",
      data: {
        token: token,
        project_id: cv.project.get("id"),
        registration: this.registration_model.toJSON(),
        line_items: this.registration_tiers.toJSON(),
      },
      dataType: "json",
      success: _.bind(function (data) {
        this.submitting_payment = false;
        this.$(".form-save").html(
          'Process Payment <i class="material-icons md-24">chevron_right</i>'
        );
        this.$(".form-save").removeClass("button-disabled");

        // Re-fetch project so that registration is there
        cv.project.fetch({
          success: _.bind(function (model, response) {
            cv.project = new cv.Project({ data: response.data }, { parse: true, synced: true });

            vent.trigger(
              "notif:success",
              "Registration payment completed, please check your inbox for a receipt."
            );

            // Do tracking
            if (cv.campaign.get("id") === "2081dWxanL4mzPOL" || cv.environment == "development") {
              window.fbq("track", "Purchase", {
                currency: cv.campaign.get("currency_code"),
                value: cv.project.get("registration.amount"),
                type: "registration",
              });
            }

            vent.trigger("setup:next_screen");
          }, this),
        });
      }, this),
      error: _.bind(function (xhr, error) {
        console.log(xhr.responseText);
        this.submitting_payment = false;
        this.$(".form-save").html('Process Payment <i class="fa fa-chevron-right"></i>');
        this.$(".form-save").removeClass("button-disabled");

        // Show an error message
        vent.trigger("notif:error", $.parseJSON(xhr.responseText).data);
      }, this),
    });
  },

  renderTiers: function () {
    var tiersView = new cv.Views.Setup.Registration.TiersView({
      collection: this.registration_tiers,
      registration_model: this.registration_model,
      discount_model: this.discount_model,
      has_registered: _.isEmpty(cv.project.get("registration")) ? false : true,
      enable_quantity: cv.campaign.get("enable_registration_quantity") == 1 ? true : false,
    });
    this.showChildView("region_tiers", tiersView);
  },

  bindStripeElements: function () {
    // Hack to prevent form submission
    document.querySelector("form").addEventListener("submit", function (e) {
      e.preventDefault();
    });

    // Setup Stripe elements
    var elements = this.stripe.elements({
      fonts: [
        {
          cssSrc: "https://fonts.googleapis.com/css?family=Roboto:400,500,700",
        },
      ],
    });

    // Create an instance of the card Element.
    this.card = elements.create("card", {
      classes: {
        base: "form-control form-stripe-element",
        invalid: "has-error",
      },
      style: {
        base: {
          color: "#555555",
          fontFamily: "Roboto",
          "::placeholder": {
            color: "#dedede",
          },
        },
      },
    });

    // Add an instance of the card Element into the `card-element` <div>.
    this.card.mount(this.$("#card-element")[0]);
    this.card.on(
      "change",
      _.bind(function (event) {
        if (event.error) {
          this.submitting_payment = false;
          this.$("#card-element").parents(".form-group").addClass("has-error");
        } else {
          this.$("#card-element").parents(".form-group").removeClass("has-error");
        }
      }, this)
    );
  },

  onAttach: function () {
    // Change document title
    document.title = "Setup | Pay Registration Fee";

    // Bind stickit
    this.stickit(this.ui_model, this.uiBindings);

    // Render tiers
    this.renderTiers();

    // Render Stripe elements if we are a new registration
    if (_.isEmpty(cv.project.get("registration"))) {
      this.bindStripeElements();
    } else {
      this.registration_model.set("amount", cv.project.get("registration.amount"));

      // Reset tiers to something else
      this.registration_tiers.each(function (model) {
        _.each(
          cv.project.get("registration.line_items"),
          function (item) {
            if (model.get("id") == item.tier_id) {
              model.set("quantity", item.quantity);
            }
          },
          this
        );
      });
    }

    // Fire facebook event
    if (cv.campaign.get("id") === "2081dWxanL4mzPOL" || cv.environment == "development") {
      window.fbq("init", 510002066733678);
      window.fbq("track", "InitiateCheckout", {
        type: "registration",
      });
    }
  },
});
